import moment from "moment";

import { formatThaiDateUi, getCreateDateTime } from "../../utils/DateUtils";

export const rcvMasterModel = () => {
    return {
        // สำหรับตารางรับ
        dateRcv: formatThaiDateUi(moment()),
        amountRcv: 0,

        // ข้อมูลทั่วไป
        rcvId: null,
        rcvNo: null,
        rcvDate: formatThaiDateUi(moment()),
        docDueDate: null,
        docPayDate: formatThaiDateUi(moment()),
        rcvStatus: 1,
        rcvType: 1,
        refDocID: null,
        refDoc: null,
        refDocDate: null,
        refProjectID: null,
        refProjectNo: null,
        compId: null,
        // transportType: 1,
        docRemark1: null,
        docRemark2: null,
        arID: null,
        arCode: null,
        arName: null,
        arAdd1: null,
        arAdd2: null,
        arAdd3: null,
        arProvince: null,
        arZipcode: null,
        arTaxNo: null,
        actionHold: null,
        discountValue: null,
        discountValueType: null,
        discountValueTotal: 0,
        discountCash: null,
        discountCashType: null,
        discountTransport: null,
        discountTransportType: null,
        isVat: null,
        docSEQ: null,
        creditTerm: null,
        creditTerm1Day: null,
        creditTerm1Remark: null,
        creditTerm2Remark: null,
        accCode: null,
        empName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem("name"),
        createdById: window.localStorage.getItem("emp_id"),
        updateDate: null,
        updateByName: null,
        updateById: null,
        approvedDate: null,
        approvedByName: null,
        approvedById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        approvedMemo: null,
        printedStatus: null,
        printedDate: null,
        printedBy: null,
        cancelMemo: null,
        bank_name: null,
        bank_acc_no: null,
        bank_acc_name: null,
        fb_Telephone: null,
        fb_Email: null,
        pay_cheque_bank: null,
        pay_cheque_no: null,
        pay_trans_type: null,
        pay_cheque_date: null,
        pay_trans_date: null,
        rcv_cash: null,
    };
};
